<template>
  <v-breadcrumbs :items="items" class="grey darken-2" dark>
    <template v-slot:default>
      <v-breadcrumbs-item to="/" :disabled="currentRouteName === 'Home'">
        <v-icon class="mr-1">mdi-home</v-icon>
        <span class="white--text">หน้าแรก</span>
      </v-breadcrumbs-item>
      <span class="mx-2 white--text" v-if="currentRouteName !== 'Home'">/</span>
      <div v-for="(item, idx) in items" :key="idx">
        <v-breadcrumbs-item active-class="v-breadcrumbs__item" :disabled="false" :to="item.to">
          <span class="white--text">{{ item.text }}</span>          
        </v-breadcrumbs-item>
        <span class="mx-2 white--text" v-if="idx != Object.keys(items).length - 1">/</span>
      </div>
    </template>
  </v-breadcrumbs>
</template>

<script>
export default {
  props: {
    items: Array
  },
  computed: {
    currentRouteName() { 
      return this.$route.name; 
    }
  }
}
</script>